module.exports = __webpack_public_path__ + "img/solution2_banner_txt.48b38b9e.png";